import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'hideEmail'
})
export class HideEmailPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }

    const emailParts = value.split('@');
    if (emailParts.length !== 2) {
      return value;  // Not a valid email
    }

    const username = emailParts[0];
    const domain = emailParts[1];

    if (username.length <= 2) {
      return `${username[0]}*****@${domain}`;
    }

    const hiddenUsername = `${username[0]}*****${username.slice(-1)}`;
    return `${hiddenUsername}@${domain}`;
  }

}

